import { MultiBulkActionSubItem } from '../MultiBulkActionButton';

export function resolvePrimaryAndSecondaryActionsCompat(
  actionItems: MultiBulkActionSubItem[],
  primaryActionItems: MultiBulkActionSubItem[],
  secondaryActionItems: MultiBulkActionSubItem[],
): {
  primaryActionItems: MultiBulkActionSubItem[];
  secondaryActionItems: MultiBulkActionSubItem[];
} {
  // if primaryActionItems or secondaryActionItems is defined - we ignore actionItems
  if (primaryActionItems.length || secondaryActionItems.length) {
    return {
      primaryActionItems,
      secondaryActionItems,
    };
  }

  // if actionItems is defined - first 2 items go as primary (3 if 3 actions in total), other as secondary
  const newPrimaryActions =
    actionItems.length <= 3 ? actionItems : actionItems.slice(0, 2);
  return {
    primaryActionItems: newPrimaryActions,
    secondaryActionItems:
      newPrimaryActions.length === 3 ? [] : actionItems.slice(2),
  };
}
